export * from './addfile.component';
